export const TeamsHowItWorks: React.FC = () => {
  return (
    <div>
      <p>
        Zocks' Teams integration allows you to have your Zocks AI Notetaker with you on your Teams meetings so that you can focus on your client while Zocks
        captures accurate, actionable, and 100% recording-free notes, so you never miss a detail.
      </p>
    </div>
  )
}
